export enum AmdEmailFormMode {
  CREATE = "CREATE",
  EDIT = "EDIT"
}

export type AmdEmailItem = {
  _id: string;
  name: string;
  email: string;
}